import {
  GET_PACKAGES,
  GET_PAYMENT_TYPE,
  GET_ROOT_ACCOUNT,
  GET_SERVICE_PAGE_INFO,
  GET_SUBSCRIBERS,
  // eslint-disable-next-line prettier/prettier
  GET_SUB_ROOT_ACCOUNT,
  SET_SUBSCRIBER_DETAILS,
  SET_LINE_REMANING_BALANCES,
  SET_LINE_INSTALLMENTS,
  SET_PREVIOUS_DEBTS,
  GET_BLACK_LIST_SUBSCRIBERS,
} from './actionsTypes'

const initialState = {
  rootAccount: {},
  subRootAccount: {},
  subscribers: {},
  paymentType: {},
  packages: {},
  servicePageInfo: {},
  subscriberDetails: {},
  lineRemainingBalances: {},
  lineInsatllments: {},
  previousDebts: {},
  blackListubscribers: {},
}

const corporateData = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ROOT_ACCOUNT:
      return {
        ...state,
        rootAccount: payload,
      }
    case GET_SUB_ROOT_ACCOUNT:
      return {
        ...state,
        subRootAccount: payload,
      }
    case GET_SUBSCRIBERS:
      return {
        ...state,
        subscribers: payload,
      }
    case GET_PAYMENT_TYPE:
      return {
        ...state,
        paymentType: payload,
      }
    case GET_PACKAGES:
      return {
        ...state,
        packages: payload,
      }
    case GET_SERVICE_PAGE_INFO:
      return {
        ...state,
        servicePageInfo: payload,
      }
    case SET_SUBSCRIBER_DETAILS:
      return {
        ...state,
        subscriberDetails: payload,
      }
    case SET_LINE_REMANING_BALANCES:
      return {
        ...state,
        lineRemainingBalances: payload,
      }
    case SET_LINE_INSTALLMENTS:
      return {
        ...state,
        lineInsatllments: payload,
      }
    case SET_PREVIOUS_DEBTS:
      return {
        ...state,
        previousDebts: payload,
      }
    case GET_BLACK_LIST_SUBSCRIBERS:
      return {
        ...state,
        blackListubscribers: payload,
      }
    default:
      return state
  }
}

export default corporateData
